const updatePlacesStr = {
  toastr: 'Lugar actualizado',
  toastr1: 'fue actualizado con éxito',
  toastrError: 'Lugar ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default updatePlacesStr;
